
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8e2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8e2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g58ck", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bb5378ea691af967$export$6503ec6e8aabbaf; }, function (v) { return $bb5378ea691af967$export$6503ec6e8aabbaf = v; });
var $bb5378ea691af967$export$6503ec6e8aabbaf;
var $bb5378ea691af967$export$f7ad0328861e2f03;
"use strict";
var $bb5378ea691af967$var$mapping = new Map();
function $bb5378ea691af967$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bb5378ea691af967$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bb5378ea691af967$var$resolve(id) {
    var resolved = $bb5378ea691af967$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bb5378ea691af967$export$6503ec6e8aabbaf = $bb5378ea691af967$var$register;
$bb5378ea691af967$export$f7ad0328861e2f03 = $bb5378ea691af967$var$resolve;

});

var $c8286508b6b41536$exports = {};

(parcelRequire("g58ck")).register(new URL("", import.meta.url).toString(), JSON.parse('["fEghO","index.0412557b.js","eEEqk","coincraft_logo_130.1b205a5d.png"]'));


//# sourceMappingURL=index.runtime.777f8de8.js.map
